import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent {
  constructor(private location: Location) {}

  public goBack() {
    this.location.back();
  }
}
